import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\PhanThiCamGiang\\onegate\\client\\core\\node_modules\\next-intl\\dist\\esm\\shared\\NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ForgorForm"] */ "D:\\PhanThiCamGiang\\onegate\\client\\core\\src\\app\\[locale]\\(auth)\\_components\\default\\forgor-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\PhanThiCamGiang\\onegate\\client\\core\\src\\app\\[locale]\\(auth)\\_components\\sso\\sso-forgor-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getLocalStorage","LocalStorageKeys","Locale"] */ "D:\\PhanThiCamGiang\\onegate\\client\\core\\src\\lib\\local-storage.ts");
